import { AxiosError } from 'axios';
import adminApi from '../../api/adminApi';
import useStore from '../../store/store';

export interface AddTermsParams {
    terms: File;
    version: number;
}

const AddTerms = async (params: AddTermsParams) => {
    const { setFormError, setIsLoading } = useStore.getState();
    setIsLoading(true);

    try {
        const formData = new FormData();
        formData.append('version', params.version.toString());
        if (params.terms) {
            formData.append('terms', params.terms);
        }

        const response = await adminApi.post('/add-terms', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const { success, errCode } = response.data;
        if (success) {
            setFormError('');
        } else if (errCode) {
            setFormError(errCode);
        } else {
            setFormError('other');
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error(e.response?.data);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default AddTerms;
